// Tab unread indicator — so an OPEN-but-unfocused browser tab shows there's something new
// (complements web push, which is for when the app is closed). Two signals:
//   • document.title → "(3) TMCChat · The Media Crowd"
//   • a red dot drawn onto the favicon (swaps to the PNG icon + dot; restores the crisp SVG at zero)
// No permissions needed. Safe/no-op if canvas or the base image aren't available.

const BASE_TITLE = (typeof document !== "undefined" && document.title) || "TMCChat";
const BASE_PNG = "/icons/icon-192.png";

let svgLink = null;      // the crisp default favicon (used when there's no unread)
let pngLink = null;      // a managed PNG link we draw the dot onto
let baseImg = null;
let baseReady = false;

function els() {
  if (pngLink) return;
  svgLink = document.querySelector('link[rel="icon"][type="image/svg+xml"]');
  pngLink = document.querySelector('link[rel="icon"][type="image/png"]');
  if (!pngLink) {
    pngLink = document.createElement("link");
    pngLink.rel = "icon"; pngLink.type = "image/png"; pngLink.href = BASE_PNG;
    document.head.appendChild(pngLink);
  }
}

function withBase(cb) {
  if (baseReady) return cb();
  const img = new Image();
  img.onload = () => { baseImg = img; baseReady = true; cb(); };
  img.onerror = () => { baseReady = false; };
  img.src = BASE_PNG;
}

function dotDataUrl() {
  try {
    const s = 64, c = document.createElement("canvas");
    c.width = s; c.height = s;
    const ctx = c.getContext("2d");
    if (baseImg) ctx.drawImage(baseImg, 0, 0, s, s);
    const r = 19;
    ctx.beginPath(); ctx.arc(s - r - 1, r + 1, r, 0, 2 * Math.PI);
    ctx.fillStyle = "#ff3b30"; ctx.fill();
    ctx.lineWidth = 5; ctx.strokeStyle = "#0b1322"; ctx.stroke();
    return c.toDataURL("image/png");
  } catch { return null; }
}

export function setTabUnread(count) {
  const n = count | 0;
  if (typeof document === "undefined") return;
  document.title = n > 0 ? `(${n > 99 ? "99+" : n}) ${BASE_TITLE}` : BASE_TITLE;
  try {
    els();
    if (n > 0) {
      withBase(() => {
        const url = dotDataUrl();
        if (!url) return;
        pngLink.href = url;
        if (svgLink) svgLink.rel = "alternate icon"; // demote the SVG so the dotted PNG wins
      });
    } else {
      if (svgLink) svgLink.rel = "icon";
      pngLink.href = BASE_PNG;
    }
  } catch { /* favicon quirks — the title badge still conveys unread */ }
}
